import { Controller } from "@hotwired/stimulus"

// Модалка «Новый макет»: показать/скрыть; закрытие по оверлею и Esc; поиск изделий.
export default class extends Controller {
  static targets = ["modal", "search", "item", "section"]

  open() { this.modalTarget.classList.remove("hidden"); this.modalTarget.classList.add("flex"); if (this.hasSearchTarget) { this.searchTarget.value = ""; this.filter() }; this._esc = (e) => { if (e.key === "Escape") this.close() }; document.addEventListener("keydown", this._esc); if (this.hasSearchTarget) this.searchTarget.focus() }
  close() { this.modalTarget.classList.add("hidden"); this.modalTarget.classList.remove("flex"); if (this._esc) document.removeEventListener("keydown", this._esc) }
  backdrop(e) { if (e.target === this.modalTarget) this.close() }

  // Клиентский фильтр: прячем изделия (item) по data-name, затем прячем рубрики (section) без видимых изделий.
  filter() {
    const q = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
    for (const el of this.itemTargets) el.hidden = q !== "" && !(el.dataset.name || "").includes(q)
    for (const sec of this.sectionTargets) {
      const anyVisible = sec.querySelectorAll("[data-new-design-modal-target=item]:not([hidden])").length > 0
      sec.hidden = !anyVisible
    }
  }
}
